import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ILocalAgendamento } from '../model/local_agendamento.model';

@Injectable()
export class LocalAgendamentoService extends EntityService<ILocalAgendamento> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'local_agendamento',
      pluralBaseEntityEndPoint: 'locais_agendamento'
    });
  }
}
